import { Link, useOutletContext } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ModuleGate = ({ module, children }) => {
  const { billing } = useOutletContext() || {};
  if (!billing) return null;
  if (!billing.modules || billing.modules.includes(module)) return children;
  return (
    <div className="flex-1 grid place-items-center p-10" data-testid={`module-locked-${module}`}>
      <div className="max-w-md text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-slate-100 grid place-items-center mb-4"><Lock className="h-5 w-5 text-slate-500" /></div>
        <h2 className="text-xl font-semibold mb-2">Module non inclus dans votre formule</h2>
        <p className="text-slate-500 mb-6">La supervision RMM (santé des postes, alertes, logiciels, mises à jour) est disponible dans une formule supérieure.</p>
        <Button asChild><Link to="/app/billing" data-testid="module-locked-upgrade">Changer de formule</Link></Button>
      </div>
    </div>
  );
};
